import styled from 'styled-components'

import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import Heading from '../Heading/Heading'

import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import Button from '../Button/Button'

export const StyledRedirectionHighlight = styled.article`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(20)};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.mobileL} {
    align-items: flex-start;
    flex-direction: column;
    gap: ${pxToRem(10)};
  }
`

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(10)};
`

export const StyledHeading = styled(Heading)``

export const StyledCKEditorContent = styled(CKEditorContent)`
  p {
    margin-bottom: 0;
  }
`

export const StyledButton = styled(Button)`
  min-width: fit-content;
`

export const StyledLabel = styled.span`
  margin-right: ${pxToRem(10)};
`

export const StyledIcon = styled(ArrowRight)`
  width: ${pxToRem(24)};
  height: ${pxToRem(23)};
  padding: ${pxToRem(3)} ${pxToRem(3)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`
